function FloatingContact() {
  const scrollToContact = () => {
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <button
      type="button"
      className="floating-contact"
      onClick={scrollToContact}
      aria-label="Contact Us"
    >
      Contact Us
    </button>
  );
}

export default FloatingContact;
